import { defineModule } from "@kubdee/sdk";
import { MODULES } from "@kubdee/shared";
import { accountingDoctypes } from "./doctypes";
import { migrations } from "./migrations";

// 🔄 To change icon, also add the new icon to apps/web/src/lib/icon-registry.ts
const MODULE_ICON = "Calculator";
const MODULE_COLOR = "#2490EF";

export default defineModule({
  name: MODULES.ACCOUNTING,
  label: "ระบบบัญชี",
  icon: MODULE_ICON,
  color: MODULE_COLOR,
  version: "1.0.0",
  dependencies: [MODULES.CORE],
  category: "finance",
  isSystemModule: false,

  schemas: {},
  routes: {},
  moduleMigrations: migrations,
  navigation: {
    label: "บัญชี",
    icon: MODULE_ICON,
    groups: [
      {
        label: "ภาพรวม",
        items: [
          {
            label: "แดชบอร์ด",
            path: "/accounting/dashboard",
            icon: "LayoutDashboard",
          },
        ],
      },
      {
        label: "ข้อมูลหลัก",
        items: [
          {
            label: "ผังบัญชี",
            path: "/accounting/chart-of-accounts",
            icon: "BookOpen",
          },
          { label: "ลูกค้า", path: "/accounting/customers", icon: "Users" },
          { label: "ผู้ขาย", path: "/accounting/suppliers", icon: "Handshake" },
          {
            label: "สินค้า/บริการ",
            path: "/accounting/items",
            icon: "Package",
          },
          { label: "ราคาขาย", path: "/accounting/price-lists", icon: "Tag" },
          {
            label: "บัญชีธนาคาร",
            path: "/accounting/bank-accounts",
            icon: "Banknote",
          },
        ],
      },
      {
        label: "ธุรกรรม",
        items: [
          {
            label: "ใบแจ้งหนี้ขาย",
            path: "/accounting/invoices?type=sales",
            icon: "FileText",
          },
          {
            label: "ใบแจ้งหนี้ซื้อ",
            path: "/accounting/invoices?type=purchase",
            icon: "FileText",
          },
          {
            label: "ใบลดหนี้ขาย",
            path: "/accounting/credit-notes?partyType=customer",
            icon: "FileMinus",
          },
          {
            label: "ใบลดหนี้ซื้อ",
            path: "/accounting/credit-notes?partyType=supplier",
            icon: "FileMinus",
          },
          {
            label: "ใบเพิ่มหนี้",
            path: "/accounting/debit-notes",
            icon: "FilePlus",
          },
          {
            label: "ใบจ่ายเงิน",
            path: "/accounting/payments",
            icon: "CreditCard",
          },
          {
            label: "ใบเสร็จรับเงิน",
            path: "/accounting/receipts",
            icon: "Receipt",
          },
          {
            label: "ทะเบียนเช็ค",
            path: "/accounting/cheques",
            icon: "Receipt",
          },
          {
            label: "รายการเดินบัญชี",
            path: "/accounting/bank-statements",
            icon: "Banknote",
          },
          {
            label: "สมุดรายวัน",
            path: "/accounting/journal-entries",
            icon: "BookMarked",
          },
          {
            label: "สินทรัพย์ถาวร",
            path: "/accounting/fixed-assets",
            icon: "Building",
          },
          {
            label: "รายการซ้ำ",
            path: "/accounting/recurring-templates",
            icon: "Repeat",
          },
        ],
      },
      {
        label: "ศูนย์ต้นทุน",
        items: [
          {
            label: "ศูนย์ต้นทุน",
            path: "/accounting/cost-centers",
            icon: "Network",
          },
        ],
      },
      // EPIC #412 Phase 3 — admin-defined analytic dimensions (campaigns,
      // regions, customer tiers, …) used as standalone tags on JE/invoice
      // allocation rows.
      {
        label: "มิติบัญชี",
        items: [
          {
            label: "ประเภทมิติ",
            path: "/accounting/dimensions/types",
            icon: "Tags",
          },
          {
            label: "ค่ามิติ",
            path: "/accounting/dimensions/values",
            icon: "Tag",
          },
        ],
      },
      {
        label: "งบประมาณ",
        items: [
          { label: "งบประมาณ", path: "/accounting/budgets", icon: "Target" },
        ],
      },
      {
        label: "ระหว่างบริษัท",
        items: [
          {
            label: "รายการระหว่างบริษัท",
            path: "/accounting/intercompany",
            icon: "ArrowLeftRight",
          },
        ],
      },
      {
        label: "ตั้งค่า",
        items: [
          {
            label: "เช็กลิสต์เริ่มระบบ",
            path: "/accounting/setup-checklist",
            icon: "ListChecks",
          },
          { label: "สกุลเงิน", path: "/accounting/currencies", icon: "Coins" },
          {
            label: "วิธีชำระเงิน",
            path: "/accounting/payment-methods",
            icon: "Wallet",
          },
          {
            label: "ปีภาษี",
            path: "/accounting/fiscal-years",
            icon: "CalendarDays",
          },
        ],
      },
      {
        // EPIC #412 Phase 4 — Distribution Rules admin entry.
        label: "ตั้งค่าระบบบัญชี",
        items: [
          {
            label: "กฎการกระจายต้นทุน",
            path: "/accounting/distribution-models",
            icon: "Split",
          },
        ],
      },
      {
        label: "ภาษี",
        items: [
          {
            label: "ยื่นแบบภาษี",
            path: "/accounting/tax-filings",
            icon: "FileSpreadsheet",
          },
          {
            label: "หัก ณ ที่จ่าย",
            path: "/accounting/wht-certificates",
            icon: "Receipt",
          },
          {
            label: "ประเภทหัก ณ ที่จ่าย",
            path: "/accounting/wht-types",
            icon: "ListChecks",
          },
          {
            label: "แม่แบบภาษี",
            path: "/accounting/tax-templates",
            icon: "Percent",
          },
        ],
      },
      {
        label: "รายงาน",
        items: [
          {
            label: "ชุดงบการเงิน",
            path: "/accounting/financial-statement-packs",
            icon: "FileSpreadsheet",
          },
          {
            label: "บัญชีแยกประเภท",
            path: "/accounting/reports/general-ledger",
            icon: "BarChart3",
          },
          {
            label: "งบทดลอง",
            path: "/accounting/reports/trial-balance",
            icon: "Scale",
          },
          {
            label: "งบกำไรขาดทุน",
            path: "/accounting/reports/profit-loss",
            icon: "TrendingUp",
          },
          {
            label: "งบดุล",
            path: "/accounting/reports/balance-sheet",
            icon: "PieChart",
          },
          {
            label: "ยอดค้างชำระ",
            path: "/accounting/reports/outstanding",
            icon: "AlertCircle",
          },
          {
            label: "กระทบยอดรับ/จ่าย",
            path: "/accounting/reports/payment-reconciliation",
            icon: "ListChecks",
          },
          {
            label: "กระทบยอดธนาคาร",
            path: "/accounting/reports/bank-reconciliation",
            icon: "Banknote",
          },
          {
            label: "ทะเบียนภาษี (ภ.พ.30)",
            path: "/accounting/reports/vat",
            icon: "FileSpreadsheet",
          },
          {
            label: "ภ.พ.36",
            path: "/accounting/reports/pp36",
            icon: "FileSpreadsheet",
          },
          {
            label: "สรุป ภ.ง.ด.3/53",
            path: "/accounting/reports/wht",
            icon: "FileSpreadsheet",
          },
          {
            label: "กำไรขาดทุนตามศูนย์ต้นทุน",
            path: "/accounting/reports/cost-center-pl",
            icon: "Network",
          },
          {
            label: "งบประมาณ vs จริง",
            path: "/accounting/reports/budget",
            icon: "BarChart3",
          },
          {
            label: "งบกระแสเงินสด",
            path: "/accounting/reports/cash-flow",
            icon: "Banknote",
          },
        ],
      },
      {
        label: "รายงานการวิเคราะห์",
        items: [
          {
            label: "P&L ต่อการเช่า",
            path: "/accounting/reports/pnl-by-rental",
            icon: "TrendingUp",
          },
          {
            label: "P&L ต่อสาขา",
            path: "/accounting/reports/pnl-by-branch",
            icon: "Building2",
          },
          {
            label: "P&L ต่อลูกค้า",
            path: "/accounting/reports/pnl-by-customer",
            icon: "Users",
          },
          // EPIC #412 Phase 5 (issue #435) — flexible pivot report.
          {
            label: "Pivot Report",
            path: "/accounting/reports/pivot",
            icon: "BarChart3",
          },
        ],
      },
    ],
  },
  permissions: {},
  hooks: {},

  doctypes: [
    {
      key: "invoices",
      label: "ใบแจ้งหนี้",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "credit-notes",
      label: "ใบลดหนี้",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "debit-notes",
      label: "ใบเพิ่มหนี้",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "payment",
      label: "การชำระเงิน",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "receipt",
      label: "ใบเสร็จรับเงิน",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "bank-accounts",
      label: "บัญชีธนาคาร",
      type: "normal",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "bank-statements",
      label: "รายการเดินบัญชี",
      type: "normal",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "cheques",
      label: "ทะเบียนเช็ค",
      type: "normal",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "journal-entries",
      label: "สมุดรายวัน",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "fixed-assets",
      label: "สินทรัพย์ถาวร",
      type: "normal",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "recurring-templates",
      label: "รายการซ้ำ",
      type: "normal",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    { key: "accounts", label: "ผังบัญชี" },
    { key: "tax-templates", label: "แม่แบบภาษี" },
    { key: "wht-certificates", label: "หนังสือรับรองหัก ณ ที่จ่าย" },
    {
      key: "tax-filings",
      label: "แบบยื่นภาษี",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    {
      key: "financial-statement-packs",
      label: "ชุดงบการเงิน",
      type: "submittable",
      branchScope: {
        type: "single",
        fields: ["branchId"],
        createField: "branchId",
      },
    },
    { key: "wht-types", label: "ประเภทหัก ณ ที่จ่าย" },
    { key: "cost-centers", label: "ศูนย์ต้นทุน" },
    { key: "dimension-types", label: "มิติบัญชี" },
    { key: "dimension-values", label: "ค่ามิติบัญชี" },
    { key: "distribution-models", label: "กฎการกระจายต้นทุน" },
    { key: "currencies", label: "สกุลเงิน" },
    { key: "budgets", label: "งบประมาณ", type: "submittable" },
    { key: "intercompany", label: "รายการระหว่างบริษัท", type: "normal" },
    { key: "items", label: "สินค้า/บริการ" },
    { key: "price-lists", label: "ราคาขาย" },
    { key: "asset-categories", label: "หมวดสินทรัพย์" },
    { key: "depreciation-schedules", label: "ตารางค่าเสื่อมราคา" },
    { key: "settings", label: "ตั้งค่า" },
    { key: "reports", label: "รายงาน" },
  ],
  availableHooks: [
    { event: "accounting.debitNote.submitted", label: "ยืนยันใบเพิ่มหนี้" },
    { event: "accounting.payment.created", label: "สร้างการชำระเงิน" },
    {
      event: "accounting.invoice.outstanding.updated",
      label: "อัพเดทยอดค้างชำระ",
    },
    {
      event: "accounting.wht.submitted",
      label: "ยืนยันหนังสือรับรองหัก ณ ที่จ่าย",
    },
    { event: "accounting.taxFiling.locked", label: "ล็อคงวดภาษี" },
  ],

  fixtures: [],

  // Doctype Admin Epic (#347) issue #423. See `./doctypes.ts` — the platform
  // boot loop in `apps/tenant-worker/src/middleware/auto-migrate.ts` reads
  // this field from every enabled module's manifest and upserts the
  // platform-default rows into `core_doctype_registry` + seeds the matching
  // `core_numbering_series` `(module, doctype, company_id=NULL)` row so
  // `generateNextNumber()` resolves on a fresh tenant without per-company
  // seeding.
  registeredDoctypes: accountingDoctypes,
});
